import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateOrgnizationPackageComponent } from "./create-orgnization-package/create-orgnization-package.component";
import { OrganizationService } from 'src/app/private/services/organization.services';
import { PackageService } from 'src/app/private/services/package.service';

@Component({
  selector: 'app-orgnization-package',
  imports: [SharedModule, CreateOrgnizationPackageComponent],
  templateUrl: './orgnization-package.component.html',
  styleUrl: './orgnization-package.component.scss'
})
export class OrgnizationPackageComponent {

  @Input() orgId: string = '';

  displayAddModal: boolean = false;
  orgDataToEdit: any = null;
  showEditOrgPackage: boolean = false;
  showDeleteModal: boolean = false;
  displayEditModel: boolean = false;

  allPackages: any[] = [];

  rows = 50;
  totalRecords = 0;
  loading = false;


  
  orgActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Organization Package',
          icon: 'pi pi-fw pi-pencil',
          command: () => { 
            this.displayEditModel = true;
          }
        },
        
      ]
    }
  ]
  constructor(
    private orgService: OrganizationService,
    private packageService: PackageService
  ) { }

  organizationPackage: any;

  ngOnInit() {
    this.getOrganizationPackage();
    this.getAllPackages();
  }

  openAddModal() {
    this.displayAddModal = true;
  }

  getOrganizationPackage() {
    const payload = {
      "where": {
        "organization_id": this.orgId
      }
    }

    this.loading = true;

    this.orgService.getOrgPackageById(payload).subscribe({
      next: (res) => {
        if(res){
          this.organizationPackage = [res];
        }else{
          this.organizationPackage = [];
        }
        console.log("orgpackage",this.organizationPackage);
        this.totalRecords = this.organizationPackage.length;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });

    

  }

  reload() {
    this.getOrganizationPackage();
  }


  getAllPackages() {
    this.loading = true;
    this.packageService.getAllPackage({}).subscribe({
      next: (res) => {
        this.allPackages = res || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }


  setOrgData(orgData: any) {
    this.orgDataToEdit = orgData;
  }





}
